export const APP_STORES = {
  appStore: 'https://apps.apple.com/br/app/unique-ingressos/id1667632306',
  googlePlay: 'https://play.google.com/store/apps/details?id=br.com.uniqueingressos.unique_ingressos_app',
} as const;
